import React, { useEffect, useRef } from "react";
import { Image as KonvaImage } from "react-konva";
import useImage from "use-image";
import { CLOUDFRONT_URL } from "../../config";
const Image = ({ layer, onClick = () => {} }) => {
  const imageRef = useRef();
  const [img] = useImage(CLOUDFRONT_URL + `/auto/` + layer.file.key);
  useEffect(() => {
    if (img) {
      imageRef.current.cache();
      imageRef.current.getLayer().batchDraw();
    }
  }, [img]);
  return <KonvaImage {...layer} image={img} ref={imageRef} onClick={onClick} />;
};
export default Image;
